module.exports = __webpack_public_path__ + "img/icon_tag104.4a8e6fa6.svg";